import axios from 'axios';
import {
  delPhotoFromProduct,
  getProductByIdUrl,
  PRODUCT_URL,
  PRODUCTS_URL,
  setProductMainPhotoUrl,
} from '../constants';
import { ILocation } from '../interfaces/locations';
import { IProductFilter } from '../interfaces/product';

export const createProduct = (files: FormData) =>
  axios.post(PRODUCT_URL, files, {
    headers: { 'content-type': 'multipart/form-data' },
  });

export const editProduct = (id: number, files: FormData) =>
  axios.post(getProductByIdUrl(id), files, {
    headers: { 'content-type': 'multipart/form-data' },
  });

export const deleteProduct = (id: number | undefined) =>
  axios.delete(getProductByIdUrl(id || -1));

export const getProductById = (id: number) => axios.get(getProductByIdUrl(id));

export const getProducts = ({
  page = 1,
  perPage = 10,
  companyId,
  categoryId,
  search,
  activity,
  filter = {
    price_from: '',
    price_to: '',
  },
}: {
  page?: number;
  perPage?: number;
  companyId?: number;
  categoryId?: number;
  search?: string;
  filter?: Partial<IProductFilter>;
  activity?: string;
  sortType?: 'new' | 'rating';
  locale?: ILocation | null;
  sort_type?: string;
}) => {
  let active: string | undefined;
  if (activity === 'active') {
    active = 'true';
  }
  if (activity === 'no_active') {
    active = 'false';
  }
  if (search) {
    return axios.get('/api/shop/products/all', {
      params: {
        page,
        per_page: perPage,
        text: search.trim() ? search : undefined,
        active,
      },
    });
  }
  if (companyId) {
    if (categoryId) {
      if (active) {
        return axios.post(`/api/shop/category/${categoryId}/products`, undefined, {
          params: {
            page,
            per_page: perPage,
            company_id: companyId,
            active,
          },
        });
      }
      return axios.post(`/api/shop/category/${categoryId}/products`, undefined, {
        params: {
          page,
          per_page: perPage,
          company_id: companyId,
        },
      });
    }
    if (active)
      return axios.get(`/api/shop/company/${companyId}/products`, {
        params: {
          page,
          per_page: perPage,
          active,
        },
      });
    return axios.get(`/api/shop/company/${companyId}/products`, {
      params: { page, per_page: perPage },
    });
  }
  if (companyId && categoryId && active) {
    return axios.post(`/api/shop/category/${categoryId}/products`, undefined, {
      params: {
        page,
        per_page: perPage,
        company_id: companyId,
        active,
      },
    });
  }
  if ((categoryId as number) >= 0) {
    if (!filter.parameters) {
      return axios.post(
        `/api/shop/category/${categoryId}/products`,
        {},
        {
          params: {
            page,
            per_page: perPage,
            // lat: locale?.lat,
            // lng: locale?.lng,
            active,
            // sort_type: sortType,
          },
        }
      );
    }
    const formData = new FormData();
    formData.append('parameters', JSON.stringify(filter.parameters));
    return axios.post(`/api/shop/category/${categoryId}/products`, formData, {
      params: {
        page,
        per_page: perPage,
        price_from: filter.price_from || undefined,
        price_to: filter.price_to || undefined,
        active,
      },
    });
  }

  if (filter.parameters) {
    const formData = new FormData();
    formData.append('parameters', JSON.stringify(filter.parameters));
    return axios.post(`/api/shop/category/${categoryId || 0}/products`, formData, {
      params: {
        page,
        per_page: perPage,
        price_from: filter.price_from || undefined,
        price_to: filter.price_to || undefined,
        active,
      },
    });
  }

  const body = {
    price_from: filter?.price_from ? +filter.price_from : null,
    price_to: filter?.price_to ? +filter.price_to : null,
  };

  return axios.post(PRODUCTS_URL, body, {
    params: {
      page,
      per_page: perPage,
      active,
    },
  });
};

export const delPhoto = (photoId: number) => axios.delete(delPhotoFromProduct(photoId));

export function setMainPhoto(id: number) {
  return axios.post(setProductMainPhotoUrl(id));
}

export const editStock = (product_id: number, body: FormData) =>
  axios.post(`/api/stock_info/${product_id}`, body);

export const searchProducts = (text: string) =>
  axios.get('/api/shop/search', { params: { text } });

export const addEnumValue = (
  parameter_id: number,
  data: {
    value: string;
  }
) => axios.post(`/api/shop/parameter_enum_value`, data, { params: { parameter_id } });

export const editEnumValue = (
  id: number,
  data: {
    value: string;
  }
) => axios.put(`/api/shop/parameter_enum_value/${id}`, data);

export const deleteEnumValue = (id: number) =>
  axios.delete(`/api/shop/parameter_enum_value/${id}`);

export const getCompanyProducts = ({
  id,
  data,
}: {
  id: number;
  data: {
    page?: number;
    per_page?: number;
    locale?: string;
    category_id?: number;
  };
}) => axios.get(`/api/shop/company/${id}/products`, { params: data });
